// extracted by mini-css-extract-plugin
module.exports = {"sm":"579","md":"1211","lg":"1600","xl":"1920"};